<template>
  <div id="SectionHeroSBTi">
    <UIContainer class="SectionHeroSBTi__container">
      <template #left>
        <!-- Main Headline -->
        <SectionTitle titleTag="h1">
          <template #title>
            Achieve SBTi validation with a credible, 1.5°C-aligned target
          </template>
        </SectionTitle>

        <!-- Description -->
        <p class="SectionHeroSBTi__description">
          Reduce carbon emissions and track your progress, with our easy-to-use
          and powerful Carbon Emission Reduction Software for SMEs, and support
          from an expert.
        </p>

        <!-- Social Proof -->
        <div class="SectionHeroSBTi__social-proof">
          <SectionSocialProof />
        </div>

        <!-- CTA Button -->
        <div class="SectionHeroSBTi__cta">
          <UIButton size="xl" theme="primary" :to="{ name: 'Demo' }">
            Schedule a call
          </UIButton>
        </div>
      </template>

      <template #right>
        <div class="SectionHeroSBTi__image-container">
          <img
            class="SectionHeroSBTi__image"
            src="../assets/hero/bg.avif"
            alt="SBTi hero background"
            fetchpriority="high"
            loading="eager"
          />
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import SectionSocialProof from '@/views/components/sections/SectionSocialProof.vue'
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
</script>

<style lang="scss" scoped>
#SectionHeroSBTi {
  .SectionHeroSBTi__container {
    padding: 2rem 2rem 3rem;
    position: relative;

    @include md {
      padding: 2.875rem 3rem 6rem;
    }
  }

  .SectionHeroSBTi__image-container {
    display: none;
    position: relative;

    @include md {
      display: block;
    }
  }

  .SectionHeroSBTi__image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    border-radius: 1.5rem;
  }

  .SectionHeroSBTi__net-zero {
    position: absolute;
    bottom: 4%;
    left: -1%;
    padding: 4% 4% 4% 7%;
    background-color: $color-white;
    box-shadow: 0px 2px 2px -1px #0010350a;
    box-shadow: 0px 4px 6px -2px #0010350a;
    box-shadow: 0px 12px 16px -4px #0010350a;
    border-radius: 1rem;
    width: 35%;
  }

  .SectionHeroSBTi__chart {
    position: absolute;
    top: -5%;
    right: -3%;
    padding: 1.5%;
    background-color: $color-white;
    box-shadow: 0px 2px 2px -1px #0010350a;
    box-shadow: 0px 4px 6px -2px #0010350a;
    box-shadow: 0px 12px 16px -4px #0010350a;
    border-radius: 1rem;
    width: 35%;
  }

  .SectionHeroSBTi__trust-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background-color: $newcolor-primary-pale;
    color: $color-ui-brand-700;
    padding: 0.5rem 1rem;
    border-radius: 2rem;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
    border: 1px solid $color-ui-brand-200;
  }

  .SectionHeroSBTi__trust-icon {
    --size: 1rem;
    --color: #{$newcolor-primary-main};
  }

  .SectionHeroSBTi__title-highlight {
    background: linear-gradient(45deg, #023025 0%, #04785e 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }

  .SectionHeroSBTi__description {
    @include font-size-18px();
    color: $color-ui-gray-cool-600;
    line-height: 1.6;
    margin-top: 1.5rem;
    margin-bottom: 2rem;
    max-width: 32rem;

    strong {
      font-weight: 600;
      color: $color-ui-gray-cool-900;
    }
  }

  .SectionHeroSBTi__social-proof {
    margin-bottom: 2rem;
  }

  .SectionHeroSBTi__cta {
    display: flex;
    align-items: center;
    justify-content: center;

    @include md {
      justify-content: flex-start;
    }
  }
}
</style>
